import auth from 'services/auth';
import api from 'services/api';
import { isAddressEmpty } from 'utils/address';
import { checkIf } from 'components/form';

export function defaultAddress() {
  return {
    country: '',
    postcode: '',
    state: '',
    street1: '',
    street2: '',
    street3: '',
    suburb: '',
    latitude: null,
    longitude: null
  };
}

export function addressForm(prefix, { shouldValidate } = {}) {
  const setup = {
    fields: addressFormFields(prefix),
    labels: addressFormLabels(prefix),
    placeholders: addressPlaceholders(prefix),
    types: addressTypes(prefix),
    extra: addressExtra(prefix),
    handlers: addressHandlers(prefix)
  };

  if (shouldValidate) {
    const isRequired = (msg) => ({ field, form }) => [ !isAddressEmpty(form.$(prefix).values()), msg ];
    const check = typeof shouldValidate === 'function' ? shouldValidate : () => true;
    setup.validators = {
      [prefix + '.street1']: [ checkIf(check, [ isRequired(' ') ]) ],
      [prefix + '.street2']: [ checkIf(check, [ isRequired(' ') ]) ],
      [prefix + '.street3']: [ checkIf(check, [ isRequired(' ') ]) ],
      [prefix + '.suburb']: [ checkIf(check, [ isRequired(' ') ]) ],
      [prefix + '.state']: [ checkIf(check, [ isRequired(' ') ]) ],
      [prefix + '.postcode']: [ checkIf(check, [ isRequired(' ') ]) ],
      [prefix + '.country']: [ checkIf(check, [ isRequired('An address is required') ]) ]
    };
  }

  return setup;
}

function addressFormFields(prefix) {
  return [
    prefix,
    prefix + '.latitude',
    prefix + '.longitude',
    prefix + '.country',
    prefix + '.postcode',
    prefix + '.state',
    prefix + '.street1',
    prefix + '.street2',
    prefix + '.street3',
    prefix + '.suburb'
  ];
}

function addressFormLabels(prefix) {
  const lang = auth.lang;
  return {
    [prefix + '.country']: 'Country',
    [prefix + '.postcode']: lang.firstUpper('address.zip'),
    [prefix + '.state']: lang.firstUpper('address.state'),
    [prefix + '.street1']: 'Street',
    [prefix + '.street2']: 'Street',
    [prefix + '.street3']: 'Street',
    [prefix + '.suburb']: lang.firstUpper('address.city')
  };
}

function addressPlaceholders(prefix) {
  return {
    [prefix + '.country']: auth.user.country,
    [prefix + '.state']: auth.isCountry('US') ? '2 Letter State Code' : undefined,
    [prefix + '.street1']: 'Line 1',
    [prefix + '.street2']: 'Line 2',
    [prefix + '.street3']: 'Line 3'
  };
}

function addressTypes(prefix) {
  return {
    [prefix + '.country']: 'selectasync'
  };
}

function addressExtra(prefix) {
  return {
    [prefix + '.country']: {
      autoCalcInitialValue: true,
      loadOptions: q => api.get(`meta/countries?q=${encodeURIComponent(q)}`).then(res => ({ options: res.data.map(c => ({ value: c.code, name: c.name })) }))
    }
  };
}

function addressHandlers(prefix) {
  return {
    [prefix + '.suburb']: {
      onChange: field => e => {
        let val = e.target.value || '';
        // Don't want numbers in city field
        val = val.replace(/[0-9]/g, '');
        field.set('value', val);
      }
    },
    [prefix + '.state']: {
      onChange: field => e => {
        let val = e.target.value || '';
        const country = field.container().$('country').value || auth.user.country;
        if (country === 'US' && val.length > 2) {
          val = val.substring(0, 2);
        }
        field.set('value', val);
      }
    }
  };
}